async function SearchProduct(code, MatrixProducts){

    for (let indexProduct in MatrixProducts)
    {

        let product = MatrixProducts[indexProduct];

        if (product.cod == code) {


            return product;

        }

    }


    let primero = MatrixProducts[0];
    return primero;

}


exports.SearchProduct = SearchProduct;